import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { THEME } from '@/common/styles/theme';

export const Form = styled.form`
	margin-top: 22px;
`;

export const FormField = styled.div`
	display: grid;
	gap: 8px;

	& + & {
		margin-top: 16px;
	}
`;

export const FormLabel = styled.label`
	font-size: 0.82rem;
	font-weight: 700;
	color: rgba(255, 245, 255, 0.92);
`;

export const FormHint = styled.p`
	margin: 0;
	font-size: 0.76rem;
	line-height: 1.4;
	color: ${THEME.muted};
`;

export const FormError = styled.p`
	margin: 0 0 14px;
	padding: 10px 12px;
	border-radius: 12px;
	font-size: 0.82rem;
	line-height: 1.4;
	color: #ffb0be;
	background: rgba(255, 80, 110, 0.08);
	border: 1px solid rgba(255, 122, 146, 0.24);
`;

export const PrimaryLink = styled(Link)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 14px 18px;
	border: 0;
	border-radius: 14px;
	font-family: ${THEME.fontApp};
	font-size: 0.92rem;
	font-weight: 800;
	color: #fff;
	text-decoration: none;
	background: ${THEME.gradientPrimary};
	box-shadow: 0 10px 28px rgba(176, 38, 255, 0.28);
	cursor: pointer;
	transition:
		transform 0.2s ease,
		opacity 0.2s ease;
	box-sizing: border-box;

	&:hover {
		transform: translateY(-1px);
		opacity: 0.95;
		color: #fff;
	}
`;

export const SecondaryLink = styled(Link)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 12px 18px;
	border-radius: 14px;
	font-size: 0.84rem;
	font-weight: 600;
	color: ${THEME.muted};
	text-decoration: none;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background: rgba(255, 255, 255, 0.03);
	transition:
		color 0.2s ease,
		border-color 0.2s ease;
	box-sizing: border-box;

	&:hover {
		color: ${THEME.text};
		border-color: rgba(255, 255, 255, 0.18);
	}
`;
